import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarProdutosOrcamento(axios, parametros) {  
    parametros.operacao = 'buscarProdutosOrcamento';      

    let retorno = {};
    
    await axios.santriPOST('/rest/produto', parametros, 180, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
  
    return retorno;
  }, 
}


// WEBPACK FOOTER //
// ./src/components/Rest/RProduto/RProdutoBuscarProdutoOrcamento.js